// extracted by mini-css-extract-plugin
export var link = "_e-0";